import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { roundSelect } from '~/store/actions/round';
import Scrollable from '~/views/Home/base/Scrollable';
import Contest from './Contest';
import './index.scss';

export default
@connect(
  ({ roundSelection }) => ({
    roundSelection,
  }),
  (dispatch) => ({
    onRoundSelect: (round, categories) => dispatch(roundSelect(round, categories)),
  }),
)
class HeaderHamburger extends Component {
  static propTypes = {
    contests: PropTypes.array.isRequired,
    roundSelected: PropTypes.any,
    colors: PropTypes.shape({
      default: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string,
      }),
      active: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string,
      }),
    }),
    onToggleAutoSwitch: PropTypes.func.isRequired,
  };

  state = {
    closed: true,
    selectedContestId: undefined,
  };

  static getDerivedStateFromProps({ roundSelected }, { selectedContestId }) {
    if (selectedContestId !== undefined || !roundSelected) {
      return null;
    }
    return {
      selectedContestId: roundSelected.externalContestId,
    };
  }

  toggleOpened = () => {
    const { closed } = this.state;

    this.setState({
      closed: !closed,
    });
  };

  close = () =>
    this.setState({
      closed: true,
    });

  ignoreEvent = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
  };

  componentDidMount() {
    window.addEventListener('mouseup', this.close, false);
    window.addEventListener('touchstart', this.close, false);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedContestId !== this.props.selectedContestId) {
      this.setState({
        selectedContestId: this.props.selectedContestId,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mouseup', this.close, false);
    window.removeEventListener('touchstart', this.close, false);
  }

  render() {
    const { closed, selectedContestId } = this.state;

    const { contests, roundSelection, roundSelected = {}, onRoundSelect, onToggleAutoSwitch, colors } = this.props;

    const buttonClassName = closed ? 'fa-bars' : 'fa-times';

    return (
      <div className="header-hamburger" onMouseUp={this.ignoreEvent} onTouchStart={this.ignoreEvent}>
        <i className={`button fa ${buttonClassName}`} onClick={this.toggleOpened} />

        <Scrollable className={`menu ${closed ? 'hide' : 'show'}`}>
          <div className="auto-switch" onClick={onToggleAutoSwitch}>
            <span className={classNames('status-indicator', roundSelection.autoSwitch ? 'active' : 'inactive')} />
            <span>Auto Switch</span>
          </div>

          <ul className="list">
            {contests.map((contest, i) => (
              <Contest
                key={`hamburger_contest_${i}`}
                contest={contest}
                selectedContestId={selectedContestId}
                onContestSelect={(contest) => {
                  if (contest.externalId !== selectedContestId) {
                    return this.setState({
                      selectedContestId: contest.externalId,
                    });
                  }

                  this.setState({
                    selectedContestId: null,
                  });
                }}
                onRoundSelect={(round, categories) => {
                  onRoundSelect(round, categories);

                  this.setState({
                    closed: true,
                  });
                }}
                roundSelected={roundSelected}
                colors={colors}
              />
            ))}
          </ul>
        </Scrollable>
      </div>
    );
  }
}
